import { useState, Fragment } from "react";
import { isoDateToString } from "../../util/format-date";
export default function DropDownBanner({ children, data, onClick }) {
  const [show, setShow] = useState(false);

  const clickHandler = () => {
    if (data.length > 0) setShow(!show);
    onClick && onClick();
  };
  return (
    <Fragment>
      {show && (
        <div
          onClick={() => setShow(false)}
          className="absolute w-screen h-screen"
        ></div>
      )}
      <div
        className="relative rounded-md cursor-pointer hover:bg-stone-800"
        onClick={clickHandler}
      >
        {children}
        {show && (
          <div className="absolute grid gap-2 p-4 overflow-scroll rounded-lg max-h-52 bg-stone-800 max-w-[800px] no-scrollbar z-100">
            {data.map((item, idx) => (
              <div key={idx} className="flex items-start space-x-4 text-xs">
                <p>{idx + 1}.</p>
                <div className="grid gap-1">
                  {Object.keys(item).map((key, idx) => (
                    <div key={idx} className="grid">
                      <p className="text-stone-400">{key}:</p>
                      {key === "link" ? (
                        <a
                          href={item[key]}
                          target="_blank"
                          className="cursor-pointer text-primary hover:underline"
                        >
                          URL
                        </a>
                      ) : (
                        <p className="text-stone-200">
                          {key.toLowerCase().includes("date")
                            ? isoDateToString(item[key])
                            : item[key]}
                        </p>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </Fragment>
  );
}
